// extracted by mini-css-extract-plugin
module.exports = {"Main":"App_Main__1yZbY"};